module.exports = __webpack_public_path__ + "images/feature/20160401_02-96e15659c5363bede8f8c717e65dd532.png";